export default __webpack_public_path__ + "static/media/song.d572de37.mp3";